import React from 'react';

const ArrowBrown = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="41" height="26" viewBox="0 0 41 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M18.2782 1.44894C19.4687 0.136672 21.5313 0.13667 22.7218 1.44894L39.765 20.2342C41.5141 22.162 40.1462 25.25 37.5432 25.25H3.4568C0.853796 25.25 -0.514084 22.162 1.23496 20.2342L18.2782 1.44894Z" fill="#713B3B"/>
    </svg>
  )
};

export default ArrowBrown;
